export const environment = {
  installedInstances: [
    "default",
    "xx",
    "asean",
    "kh",
    "kh-moc",
    "jp",
    "sg",
    "bt",
    "vc",
    "cv",
  ],
  env: "awsdev",
  enableLogging: false,
  appUrl: "https://ipoffice-efiling-dev.ipobs.dev.web1.wipo.int",
  dataServicesApi: "https://ipas-ipoffice-dev.ipobs.dev.web1.wipo.int",
  authApi: "https://auth.iims.ipobs.dev.web1.wipo.int/oauth2/token",
  authApiUsername: "669h7kl059b8i246an6v455vja",
  authApiPassword: "9nso5vg4rmf7v1rfr6adjt4ncd6e4c5694ti71mp5pstg7h12li",
  backendUrl:
    "https://ipoffice-efiling-dev.ipobs.dev.web1.wipo.int/services/users",
  cognito: {
    region: "eu-central-1",
    userPoolId: "eu-central-1_aIn5Yy5c5",
    clientId: "7q84lagj3foqvelcgkkmvqqnj2",
    authority: "auth.iims.ipobs.dev.web1.wipo.int",
    redirectUrl:
      "https://ipoffice-efiling-dev.ipobs.dev.web1.wipo.int/auth-callback",
    postLogoutRedirectUri:
      "https://ipoffice-efiling-dev.ipobs.dev.web1.wipo.int/logged-out",
    scope:
      "aws.cognito.signin.user.admin email im-api/im-access openid profile",
    responseType: "code",
  },
};

export const configuration = {
  bn: {
    name: "Intellectual Property of BRUNEI DARUSSALAM",
    officeCode: "bn",
    logo: "/assets/images/bn-logo.png",
    availableLangs: ["en"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  br: {
    name: " Instituto Nacional da Propriedade Industrial INPI",
    officeCode: "br",
    logo: "/assets/images/br-logo.png",
    availableLangs: ["en", "pt"],
    defaultLanguage: "pt",
    defaultLandingModule: "dashboard",
    efilingEnabled: false,
    hideTitle: true,
  },
  bt: {
    name: "Ministry of Industry,Commerce and Employment (MoICE)",
    officeCode: "bt",
    logo: "/assets/images/bt-logo.jpeg",
    availableLangs: ["ar", "en", "fr", "id", "jp", "kh", "ms", "vi"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  cv: {
    name: "IGQPI - Instituto de Gestão da Qualidade e da \n Propriedade Intelectual",
    officeCode: "cv",
    logo: "/assets/images/cv-logo.jpeg",
    availableLangs: ["en", "fr"],
    defaultLanguage: "fr",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: false,
  },
  in: {
    name: "IP India",
    officeCode: "in",
    logo: "/assets/images/in-logo.png",
    availableLangs: ["en"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: false,
    hideTitle: true,
  },
  "kh-moc": {
    name: "KH MOC",
    officeCode: "kh-moc",
    logo: "/assets/images/kh-moc-logo.png",
    availableLangs: ["ar", "en", "fr", "id", "jp", "kh", "ms", "vi"],
    defaultLanguage: "fr",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  la: {
    name: "DIP Lao PDR",
    officeCode: "la",
    logo: "/assets/images/la-logo.png",
    availableLangs: ["en"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  my: {
    name: "Intellectual Property Coorporation of Malaysia",
    officeCode: "my",
    logo: "/assets/images/my-logo.png",
    availableLangs: ["en"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  ph: {
    name: "Intellectual Property of the Philippines",
    officeCode: "ph",
    logo: "/assets/images/ph-logo.png",
    availableLangs: ["en"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  sg: {
    name: "IPOS Singapore",
    officeCode: "sg",
    logo: "/assets/images/sg-logo.png",
    availableLangs: ["en", "zh", "ms", "ta"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: false,
    hideTitle: true,
  },
  th: {
    name: "DIP Thailand",
    officeCode: "th",
    logo: "/assets/images/th-logo.png",
    availableLangs: ["en", "th"],
    defaultLanguage: "th",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  vc: {
    name: "CIPO St. Vincent & Grenadines",
    officeCode: "vc",
    logo: "/assets/images/vc-logo.png",
    availableLangs: ["en", "fr", "id", "jp", "ar"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: false,
  },
  vn: {
    name: "IP Vietnam",
    officeCode: "vn",
    logo: "/assets/images/vn-logo.png",
    availableLangs: ["en", "vi"],
    defaultLanguage: "vi",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: true,
  },
  xx: {
    name: "WIPO IP Office Support Platform",
    officeCode: "xx",
    logo: "/assets/images/wipo-logo.png",
    availableLangs: ["ar", "en", "fr", "id", "jp", "kh", "ms", "vi"],
    defaultLanguage: "en",
    defaultLandingModule: "dashboard",
    efilingEnabled: true,
    hideTitle: false,
  },
};
